import { useAuth } from '@/contexts/AuthContext';
import type { UserRole } from '@/types';

/**
 * Returns the propertyId and role for the authenticated property manager or
 * supervisor. Returns null if the user is not a PM/supervisor or not yet loaded.
 *
 * `role` lets surfaces that are shared between property_manager and
 * security_supervisor (the /manager/* dashboard) gate out the data and cards
 * that the server restricts to property managers only — supervisors get a 403
 * on devices, modules, and the invitation list (security-model.md).
 */
export function usePmProperty(): { propertyId: string; role: UserRole } | null {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.propertyRoles.find(
    (r) => r.role === 'property_manager' || r.role === 'security_supervisor',
  );
  if (!role?.propertyId) return null;
  return { propertyId: role.propertyId, role: role.role };
}
